import React, { useState, useEffect, useCallback } from 'react'
import { useTranslation } from 'react-i18next'
import { Checkbox, Link } from '../../../ui'
import { useStore } from '../../../StateProvider'
import { useLocation } from 'react-router-dom'
import queryString from 'query-string'
import { ECN_ACK_API_PATH } from '../../../constants/routes'
import { useParamsObj } from '../../utils/hooks'
import { getUserValue, useGetPlatform } from '../utils'

const ExternalEcnAgreement = ({ name, label, text, linkText, required, showLabel }) => {
  const { t, i18n: { language } } = useTranslation()
  const [isChecked, setIsChecked] = useState(false)
  const [isVisible, setIsVisible] = useState(false)
  const [url, setURL] = useState('')
  const location = useLocation()
  const [{ form, form: { accId }, user, user: { brokerGroup, utmCampaign, deptCode, fundId } }, dispatch] = useStore()
  const { depositCurrency, isEcn, ctierId } = form[accId]
  const txt = text ? t(`generatedField.${text}`) : ''
  const platform = useGetPlatform()
  const paramsObj = useParamsObj({ brokerGroup, utmCampaign, deptCode, fundId, search: location.search, platform, ctierId, lang: language })
  const userValue = getUserValue(accId, user, name)
  const linkTxt = linkText ? t([`generatedField.${linkText}_${platform}`, `generatedField.${linkText}`]) : ''

  const onChange = useCallback(() => {
    setIsChecked(prevIsChecked => {
      const currentIsChecked = !prevIsChecked
      dispatch({ type: 'setExtFieldValue', name, value: currentIsChecked })
      dispatch({ type: 'setValidationFld', name, value: currentIsChecked })
      return currentIsChecked
    })
  }, [name])

  useEffect(() => {
    setIsChecked(false)
    dispatch({ type: 'setExtFieldValue', name, value: false })
    dispatch({ type: 'setValidationFld', name, value: false })
  }, [ctierId])

  useEffect(() => {
    const params = { ...paramsObj, depositCurrency }
    const strParams = queryString.stringify(params)
    setURL(`${ECN_ACK_API_PATH}?${strParams}`)
  }, [depositCurrency, paramsObj])

  useEffect(() => {
    setIsVisible(isEcn)
    if (isEcn) {
      if (userValue) {
        dispatch({ type: 'setExtFieldValue', name, value: userValue })
        dispatch({ type: 'setValidationFld', name, value: userValue })
        setIsChecked(userValue)
      } else {
        dispatch({ type: 'addValidationFld', name })
        setIsChecked(false)
      }
    } else {
      dispatch({ type: 'removeFieldValue', name })
      dispatch({ type: 'removeValidationFld', name })
    }
  }, [isEcn, userValue])

  return isVisible ? (
    <Checkbox
      key={`checkbox-${name}`}
      name={name}
      onChange={onChange}
      label={showLabel ? t(label) : null}
      isChecked={isChecked}
    >
      {txt}
      <Link href={url} target='_blank'>
        {linkTxt}
      </Link>
    </Checkbox>
  ) : null
}

const getExternalEcnAgreementFields = checkboxField => {
  const { i18n, name, required, text, linkText, order, showLabel } = checkboxField

  return (
    <ExternalEcnAgreement
      label={i18n ? `generatedField.${i18n}` : ''}
      name={name}
      text={text}
      linkText={linkText}
      showLabel={showLabel}
      required={required}
      key={name}
      order={order}
    />
  )
}

export { ExternalEcnAgreement, getExternalEcnAgreementFields }
